import React from 'react';
import './PayrollProduct.css';

const PayrollProduct = () => {
  return (
    <div className="payroll-product-page">
      <section className="page-hero">
        <div className="container">
          <div className="section-label">Product</div>
          <h1>PeopleX HR Platform</h1>
          <p>Intelligent payroll automation platform</p>
        </div>
      </section>
      
      <section className="page-content">
        <div className="container">
          <p>Payroll Product page content will be converted from the original HTML file.</p>
        </div>
      </section>
    </div>
  );
};

export default PayrollProduct;
